import queryString from 'query-string';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Args = {
  name: string;
};

export function useQueryParamState({
  name,
}: Args): [string | undefined, (value: string | undefined) => void] {
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = queryString.parse(location.search);

  const rawValue = searchParams[name];
  const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;

  const setValue = useCallback(
    (newValue: string | undefined) => {
      const search = queryString.stringify({
        ...searchParams,
        [name]: newValue,
      });

      navigate({ pathname: location.pathname, hash: location.hash, search });
    },
    [navigate, location, name, searchParams],
  );

  return [value || undefined, setValue];
}
